import React, { useState, useEffect } from 'react'
import callApi from 'services/api'
import { getList } from './apis'
import {
  useResetDependentFields,
  useResetDependentFields2,
} from './useResetDependentFieldsNew'
import {
  defaultPunishment,
  appealOutcomeOptions,
  decidedPendingOptions,
  appealOutcomeRevisionOptions
} from './delinquencies_constants'

import { DEFormContext } from './context/DEFormContext'
import { FormikProvider } from "formik"
import BasicDetails from './departmental_enquiry/BasicDetailsSection'
import StatusSection from './departmental_enquiry/StatusSection'
import ResultSection from './departmental_enquiry/ResultSection'
import AppealSection from './departmental_enquiry/AppealSection'
import RevisionSection from './departmental_enquiry/RevisionSection'
import RemarkSection from './departmental_enquiry/RemarkSection'

// Status options

const DEForm = ({ formik }) => {

  const [punishmentOption, setPunishmentOption] = useState([])
  const [punishmentSecondaryOption, setPunishmentSecondaryOption] = useState([])
  const [punishmentThirdOption, setPunishmentThirdOption] = useState([])
  const [resultDeOption, setresultDeOption] = useState()

  const [punishmentImposed, setpunishmentImposed] = useState()
  const [filed, setFiled] = useState()
  const [punishmentSecondaryTypeOption, setPunishmentSecondaryTypeOption] = useState()

  const [unitOptions, setUnitOptions] = useState([])
  const [subUnitOptions, setSubUnitOptions] = useState([])

  // useResetDependentFields2(
  //   formik,
  //   'deAnyPetiton', if value of deAnypeition is 
  //   ['no'],          no then
  //   ['deCourtCase']   Value of deCourtCase reset
  // )


  //   useResetDependentFields(
  //   formik,
  //   'deResultDe', if value of deResultDe
  //   ['Punishment Imposed'],  other then punishment Imposded then
  //   ['dePunishment', 'annualStoppage'] value of dePunishment and annualstoppage will be reset
  // )

  useResetDependentFields2(
    formik,
    'deStatus',
    ['pending'],
    [
      'deAppealOutcome',
      'annualStoppage',
      'deResultDe',
      'dePunishment',
      'dePunishmentType',
      'dePunishmentSecondaryType',
      'dePunishmentSecondary',
      'annualStoppageSecondary',
      'deRevisionAppealOutcome',
      'dePunishmentThird',
      'annualStoppageThird',
      'deAnyPetiton',
      'deCourtCase',
      'deRemark'
    ]
  )

  useResetDependentFields2(
    formik,
    'deAnyPetiton',
    ['no'],
    ['deCourtCase']
  )

  useResetDependentFields(
    formik,
    'deResultDe',
    ['Punishment Imposed'],
    ['dePunishment', 'annualStoppage']
  )

  useResetDependentFields(
    formik,
    'deAppealOutcome',
    ['partially', 'punishmentEnhanced'],
    ['dePunishmentSecondary', 'annualStoppageSecondary']
  )

  useResetDependentFields(
    formik,
    'deRevisionAppealOutcome',
    ['partially', 'punishmentEnhanced'],
    ['dePunishmentThird', 'annualStoppageThird']
  )

  // useResetDependentFields(
  //   formik,
  //   'deAppealOutcome',
  //   ['partially'],
  //   ['dePunishmentSecondary']
  // )

  useResetDependentFields(
    formik,
    'dePunishment',
    Object.values(defaultPunishment),
    ['annualStoppage']
  )

  useResetDependentFields(
    formik,
    'dePunishmentSecondary',
    Object.values(defaultPunishment),
    ['annualStoppageSecondary']
  )

  const getUnit_v2 = async (params) => {
    try {
      const response = await callApi(
        `filtermaster?${params}`,
        'GET',
        null,
        true,
        true
      )

      if (response.success) {
        return response.body.data
      }
    } catch (err) {
      alert('Failed to fetch ')
    }
  }
  const getUnits = async (id) => {
    const params = new URLSearchParams({
      filter: id
        ? JSON.stringify({ parentId: id })
        : JSON.stringify({ type: 'unit' }),
      sort_order: '1',
      page: '1',
      limit: '10',
    })
    const data = await getUnit_v2(params)
    if (id) {
      return data
    } else {
      return data
    }
  }



  const getPunishmentMaster = async () => {
    const data = await getList('punishment')

    const newData = [
      ...data,
      {
        id: defaultPunishment.PermanentEffect,
        name: defaultPunishment.PermanentEffect,
        parentId: [],
        type: 'punishment',
      },
      {
        id: defaultPunishment.TemporaryEffect,
        name: defaultPunishment.TemporaryEffect,
        parentId: [],
        type: 'punishment',
      },
    ]

    setPunishmentOption(newData)
    setPunishmentSecondaryOption(newData)
    setPunishmentThirdOption(newData)
  }

  const getResultDE = async () => {
    try {
      const data = await getList('result_de')
      setresultDeOption(data)
      const id = data.find(x => x.name === "Punishment Imposed")?.name
      const filedId = data.find(x => x.name === "Filed")?.name

      setpunishmentImposed(id)
      setFiled(filedId)
    }
    catch (err) {
      alert('Failed to fetch ')
    }
  }



  useEffect(() => {
    getPunishmentMaster()
    getResultDE()
    const getUnitList = async () => {
      const data = await getList('unit')

      setUnitOptions(data)
    }

    getUnitList()
  }, [])


  // Sub-unit
  useEffect(() => {
    const fetchSubUnits = async () => {
      if (formik.values.deUnit) {
        const units = await getUnits(formik.values.deUnit)
        setSubUnitOptions(units)
      } else {
        setSubUnitOptions([])
      }
    }

    fetchSubUnits()
  }, [formik.values.deUnit])


  useEffect(() => {
    if (
      formik.initialValues.dePunishment &&
      !formik.values.dePunishment &&
      punishmentOption?.length
    ) {
      formik.setFieldValue(
        "dePunishment",
        formik.initialValues.dePunishment
      )
    }

    if (formik.initialValues.annualStoppage) {
      formik.setFieldValue(
        "annualStoppage",
        formik.initialValues.annualStoppage
      )
    }
  }, [punishmentOption, formik.initialValues.annualStoppage])



  const contextValue = {
    unitOptions,
    subUnitOptions,
    decidedPendingOptions,
    resultDeOption,
    punishmentOption,
    punishmentImposed,
    defaultPunishment,
    appealOutcomeOptions,
    punishmentSecondaryOption,
    appealOutcomeRevisionOptions,
    punishmentThirdOption
  }


  return (
    <>
      {/* 🔹 Basic Details */}
      {/* <pre>{JSON.stringify({ values: formik.values, errors: formik.errors, touched: formik.touched, InitialValues: formik.initialValues }, null, 2)}</pre> */}
      <FormikProvider value={formik}>
        <DEFormContext.Provider value={contextValue}>
          <BasicDetails />
          <StatusSection />
          {formik.values.deStatus === 'decided' && <ResultSection />}
          {(formik.values.deStatus === 'decided' && formik.values.deResultDe != "" && formik.values.deResultDe != filed) && <AppealSection />}
          {(formik.values.deStatus === 'decided' && formik.values.deResultDe != "" && formik.values.deResultDe != filed) && <RevisionSection />}
          <RemarkSection />
        </DEFormContext.Provider>
      </FormikProvider>
    </>
  )
}

export default DEForm

